<template>
  <v-list class="mt-12">
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        exact
        active-class="nav-link-active"
        :to="{ name: 'dashboardMentor', params: { id: userId } }"
      >
        <span class="home-link" v-if="isExpanded">Home</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-view-dashboard</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        exact
        active-class="nav-link-active"
        :to="{ name: 'detailsMentorView', params: { id: userId } }"
      >
        <span class="profile-link" v-if="isExpanded">Mentee Profile</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-account-details</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'coursesGridMentor', params: { id: userId } }"
      >
        <span class="learning-link" v-if="isExpanded">Learning Resources</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-school</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'MemberAssessments', params: { id: userId } }"
      >
        <span class="assessment-link" v-if="isExpanded">Assessments</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-certificate-outline</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'documentsListMentor', params: { id: userId } }"
      >
        <span class="documents-link" v-if="isExpanded">Documents</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-file-document-box-outline</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'memberMessages', params: { id: userId } }"
      >
        <span class="text-message-link" v-if="isExpanded">Text Messaging</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-cellphone-iphone</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'toolsAssign', params: { id: userId } }"
      >
        <span class="text-message-link" v-if="isExpanded">Tools</span>
        <v-list-item-icon v-else>
          <v-icon>mdi-tools</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
    <v-list-item class="d-flex justify-center">
      <router-link
        class="nav-link"
        active-class="nav-link-active"
        :to="{ name: 'systemMessageMentor', params: { id: userId } }"
      >
        <span class="system-message-link" v-if="isExpanded"
          >System Messaging</span
        >
        <v-list-item-icon v-else>
          <v-icon>mdi-bell</v-icon>
        </v-list-item-icon>
      </router-link>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  data: function() {
    return {}
  },
  props: {
    isExpanded: { type: Boolean, default: true }
  },
  computed: {
    userId: {
      get() {
        let id = this.$store.state.globals.menteeId
          ? this.$store.state.globals.menteeId
          : this.$route.params.id
        return id
      },
      set(value) {
        this.$store.commit("globals/setMenteeId", value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../scss/variables";

a:link {
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 600;
}

.nav-link {
  color: $dark-grey;
}

.nav-link-active {
  color: $light-grey;
}
.v-list-item {
  line-height: 6em;
}

span.home-link {
  text-transform: none !important;
  color: $dark-grey;
  font-style: italic;
}

span.learning-link {
  color: $dark-blue;
}

span.assessment-link {
  color: $light-yellow;
}

span.documents-link {
  color: $orange;
}

span.profile-link {
  color: $light-grey;
}
span.text-message-link {
  color: $dark-yellow;
}

span.system-message-link {
  color: $orange;
}
</style>
